import {
  UPDATE_LAYOUT_HEIGHTS,
  SET_LAYOUT_WITH_PROMPT,
  LayoutActionTypes,
  LayoutState,
} from "./layout.types";

const initialState: LayoutState = {
  headerHeight: 0,
  footerHeight: 0,
  primaryNavigationHeight: 0,
  staticNotificationHeight: 0,
  eulaHeaderHeight: 0,
  eulaFooterHeight: 0,
  isWithPrompt: false,
};

export const reducer = (
  state: LayoutState = initialState,
  action: LayoutActionTypes
): LayoutState => {
  switch (action.type) {
    case UPDATE_LAYOUT_HEIGHTS: {
      return { ...state, ...action.payload };
    }
    case SET_LAYOUT_WITH_PROMPT: {
      return { ...state, isWithPrompt: action.payload };
    }
    default:
      return state;
  }
};
